import { NextSeo, ProductJsonLd } from 'next-seo';

export function ProductSeo({ deal, story }: { deal: any; story: any }) {
  let title = deal.public_name;

  if (story.meta_title) {
    title += ` - ${story.meta_title}`;
  }

  return (
    <>
      <NextSeo
        title={title}
        canonical={`https://appsumo.com/${deal.get_absolute_url}`}
        openGraph={{
          type: 'article',
          title,
          description: story?.card_description,
          images: [
            {
              url: deal.media_url,
            },
          ],
        }}
      />
      <ProductJsonLd productName={deal.public_name} />
    </>
  );
}
